import { render, staticRenderFns } from "./ThingDataTabComponent.vue?vue&type=template&id=7226638b&scoped=true"
import script from "./ThingDataTabComponent.js?vue&type=script&lang=js&external"
export * from "./ThingDataTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./ThingDataTabComponent.vue?vue&type=style&index=0&id=7226638b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7226638b",
  null
  
)

export default component.exports